import { IPlayResponse, IStopRequest } from '@loquis/shared';
import axios from 'axios';
import { Loquis } from '../interfaces/loquis.interface';

export const getLoquis = (loquisId: number) => {
  return axios.get<unknown, Loquis>('/int/loquis/' + loquisId);
};

export const loquisPlay = (loquisId: number) => {
  let href = window.location.href.replace('localhost:3000', 'challenge-dev.loquis.com');
  let source_ref = window.encodeURIComponent(href);

  return axios.put<any, IPlayResponse>('/int/loquis/' + loquisId + '/play', {
    origin: 'web',
    source_type: 'challenge',
    source_ref,
  });
};

export const loquisStop = (loquisId: number, payload: IStopRequest) => {
  return axios.put<any, any>('/int/loquis/' + loquisId + '/stop', payload);
};
